import { IPushbackOrderDetails } from "../../../models/configuration/pushback/IPushbackLoans";
import { Action, ActionType } from "../../actions";

interface PushbackOrderDetailsState {
  loading: boolean;
  error: string | null;
  data: IPushbackOrderDetails | null;
}

const initialState = { loading: false, error: null, data: null };

const pushbackOrderDetailsReducer = (
  state: PushbackOrderDetailsState = initialState,
  action: Action
): PushbackOrderDetailsState => {
  switch (action.type) {
    // GET DATA
    case ActionType.GET_PUSHBACK_ORDER_DETAILS:
      return { ...state, loading: true, error: null };
    case ActionType.GET_PUSHBACK_ORDER_DETAILS_FAILURE:
        return { ...state, loading: false, error: action.payload };
    case ActionType.GET_PUSHBACK_ORDER_DETAILS_SUCCESS:
        return { ...state, loading: false, error: null, data: action.payload };
    case ActionType.CONFIG_ID_CHANGED:
        return initialState;
    default:
        return state;
  }
};

export default pushbackOrderDetailsReducer;